// extracted by mini-css-extract-plugin
module.exports = {"row":"CountryCalendarLegendRow_row__3cgvS","rowScrollbar":"CountryCalendarLegendRow_rowScrollbar__Ip-1L","rowHeight":"CountryCalendarLegendRow_rowHeight__46J0D"};